<template>
    <div>

        <uzhnet-back-button @click="$router.push('/main')" />

        <div class="all-profiles-view">
            <div class="header-block">
                <div class="barrier">
                    <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                        <path d="M114 1H0" stroke="#CACACA"/>
                    </svg>
                </div>
                <div class="label">
                    {{ $t('profileSelectingPage.profilesHeader') }}
                </div>
                <div class="barrier">
                    <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                        <path d="M18 11H132" stroke="#CACACA"/>
                    </svg>
                </div>
            </div>

            <div class="add-new-account-form">
                <div class="add-new-account-form__input">
                    <div class="add-new-account-form__label">
                        {{ $t('addProfilePage.enterLoginLabel') }}
                    </div>
                    <div class="add-new-account-form__input-container">
                        <uzhnet-input class="w-92" :placeholder="$t('loginPage.login')" :fontSize="'14px'" v-model="login"/>
                    </div>
                </div>
                <div class="add-new-account-form__input">
                    <div class="add-new-account-form__label">
                        {{ $t('addProfilePage.enterPasswordLabel') }}
                    </div>
                    <div class="add-new-account-form__input-container">
                        <uzhnet-input class="w-92" :placeholder="$t('loginPage.password')" :fontSize="'14px'" :contentType="'password'" v-model="password"/>
                    </div>
                </div>
            </div>

            <div v-if="responseData?.user_data?.status != false" class="new-account-card-wrapper">
                <div class="new-account-card">
                    <div>
                        <img src="@/assets/images/one-profile-icon.svg" >
                    </div>
                    <div class="new-account-card-content">
                        <div class="new-account-card-content__login">{{ responseData?.user_data.login }}</div>
                        <div class="new-account-card-content__address">{{ locale == 'en' ? transliterate(responseData?.user_data.address_formatted) : responseData?.user_data.address_formatted }}</div>
                    </div>
                    <div class="new-account-card__info">
                        {{ $t('addProfilePage.ifDataCorrect') }}<br>{{ $t('addProfilePage.pressAddProfile') }}
                    </div>
                </div>
            </div>

            <div class="footer-wrapper" style="width: 100%; min-height: 520px;">
                <div v-if="responseData?.user_data?.status != false" class="selected-tariff__footer">
                    <uzhnet-button @click="processLogin" class="w-92" :label="$t('addProfilePage.addButton')" />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import '@/assets/scss/add-new-account.scss';

import { calculateFingerprint } from '@/services/fingerprint'
import { encryptMessage } from '@/services/cryptoUtils'
import ApiManager from '@/services/ApiManager'

import { addAccount, getAccountByLogin, updateAccount } from '@/db/accountService';

import { useMainStore } from '@/store/mainStore'

import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n';

function transliterate(text) {
    const ukToEnMap = {
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'H', 'Ґ': 'G', 'Д': 'D',
        'Е': 'E', 'Є': 'Ye', 'Ж': 'Zh', 'З': 'Z', 'И': 'Y', 'І': 'I',
        'Ї': 'Yi', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
        'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
        'Ф': 'F', 'Х': 'Kh', 'Ц': 'Ts', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Shch',
        'Ь': '', 'Ю': 'Yu', 'Я': 'Ya',
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd',
        'е': 'e', 'є': 'ie', 'ж': 'zh', 'з': 'z', 'и': 'y', 'і': 'i',
        'ї': 'i', 'й': 'i', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
        'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch',
        'ь': '\'', 'ю': 'iu', 'я': 'ia'
    };

    if (text) {
        return text.split('').map(char => ukToEnMap[char] || char).join('');
    } else {
        return text
    }
}

export default {
    name: 'AddNewAccount',

    setup() {
        const fingerprint = ref('')

        const login = ref('')
        const password = ref('')

        const router = useRouter()
        const store = useMainStore()

        const { locale } = useI18n()

        const maybeAccount = ref(null)
        const responseData = ref({
            user_data: {
                status: false
            }
        })

        watch(password, async () => {
            const response = await ApiManager.authorize({
                'login': login.value,
                'password': password.value
            })
            responseData.value = response.data
        })

        onMounted(async () => {
            fingerprint.value = await calculateFingerprint()
        })

        const processLogin = async () => {
            if (responseData.value.user_data.status != false) {
                maybeAccount.value = await getAccountByLogin(login.value)

                if (maybeAccount.value) {
                    const encryptedData = await encryptMessage(responseData.value.auth_token, fingerprint.value)
                    await updateAccount(login.value, {
                        login: login.value,
                        address: responseData.value.user_data.address_formatted,
                        token: encryptedData.encrypted,
                        iv: encryptedData.iv
                    })
                } else {
                    const encryptedData = await encryptMessage(responseData.value.auth_token, fingerprint.value)
                    await addAccount({
                        login: login.value,
                        address: responseData.value.user_data.address_formatted,
                        token: encryptedData.encrypted,
                        iv: encryptedData.iv
                    })
                }

                const clientDataResponse = await ApiManager.getUserInfo(responseData.value.auth_token)
                const clientDataResponseData = clientDataResponse.data

                const clientInternetResponse = await ApiManager.getUserInternet(responseData.value.auth_token)
                const clientInternetData = clientInternetResponse.data

                const clientTvResponse = await ApiManager.getUserTv(responseData.value.auth_token)
                const clientTvData = clientTvResponse.data

                store.setUserData(clientDataResponseData)
                store.setUserInternetData(clientInternetData)
                store.setUserTvData(clientTvData)

                router.push('/main')
            } else {
                login.value = ''
                password.value = ''
            }
        }

        return {
            processLogin,
            login,
            password,

            responseData,
            locale,
            transliterate: transliterate
        }
    }
}
</script>
